// reactstrap components
import React, { useEffect } from "react";

import Container from "reactstrap/lib/Container";

import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import { Card } from "reactstrap";
import {
  Mic,
  Network,
  Settings,
  FileText,
  Globe,
  Lightbulb,
  Building2,
  HardHat,
  Map,
  Wrench,
} from "lucide-react";

function Event({ text, location }) {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928 ? true : false;
  useEffect(() => {
    const common = {
      containment: "#bgndVideo1",
      autoPlay: true,
      mute: true,
      startAt: 20,
      opacity: 1,
      loop: false,
      ratio: "4/3",
      addRaster: true,
    };

    const videos = [
      {
        videoURL: "wsuuTzNfLt8",
        ...common,
      },
    ];
    if (size) {
      window.jQuery("#bgndVideo1").YTPlaylist(videos, false);
    }
  }, []);

  return (
    <div className="section pt-4" style={{ backgroundColor: !size ? "#000" : "transparent" }}>
      {size && (
        <div
          style={{
            background: "#000",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            zIndex: -100,
            marginLeft: "auto",
            marginRight: "auto",
            pointerEvents: "none",
          }}
        >
          <div
            id="bgndVideo1"
            className="section player"
            style={{ background: "transparent", height: "100%" }}
          ></div>
        </div>
      )}
      {size && (
        <div
          className="overlay-primary"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            zIndex: -99,
            pointerEvents: "none",
          }}
        />
      )}
      <div
        className={size ? "section" : "section"}
        style={{
          background: "transparent",
          position: "relative",
          zIndex: 1,
        }}
        data-parallax={true}
      >
        <Container>
          {/* Focus Areas Section */}
          <Row className="justify-content-center mb-5">
            <Col className="ml-auto mr-auto text-center" md={12}>
              <h1
                className="text-center text-g mb-3"
                style={{
                  fontSize: size ? "3.5rem" : "2rem",
                  fontWeight: "700",
                  letterSpacing: "0.5px",
                  background: "linear-gradient(135deg, #ffb41f 0%, #ccb63a 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                FOCUS AREAS
              </h1>
              <div
                style={{
                  width: "100px",
                  height: "4px",
                  background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
                  borderRadius: "2px",
                  margin: "0 auto 3rem",
                }}
              />
            </Col>
          </Row>

          <Row className="justify-content-center mb-5">
            {focusAreas.map((area, i) => (
              <Col
                key={i}
                xs={6}
                lg={3}
                md={6}
                className="mb-4"
                style={{
                  paddingLeft: "15px",
                  paddingRight: "15px",
                }}
              >
                <Card
                  className="focus-area-card mb-0"
                  style={{
                    background: "rgba(255, 255, 255, 0.05)",
                    backdropFilter: "blur(20px)",
                    border: "1px solid rgba(255, 180, 31, 0.2)",
                    borderRadius: "20px",
                    padding: size ? "2rem" : "1.5rem",
                    height: "100%",
                    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    position: "relative",
                    overflow: "hidden",
                    cursor: "pointer",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "rgba(255, 180, 31, 0.1)";
                    e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.5)";
                    e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(255, 180, 31, 0.3)";
                    const icon = e.currentTarget.querySelector(".focus-area-icon");
                    if (icon) {
                      icon.style.transform = "scale(1.15) rotate(5deg)";
                      icon.style.filter = "drop-shadow(0 8px 16px rgba(255, 180, 31, 0.5))";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                    e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.2)";
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                    const icon = e.currentTarget.querySelector(".focus-area-icon");
                    if (icon) {
                      icon.style.transform = "scale(1) rotate(0deg)";
                      icon.style.filter = "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.3))";
                    }
                  }}
                >
                  {/* Gradient overlay on hover */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "linear-gradient(135deg, rgba(255, 180, 31, 0.05) 0%, rgba(204, 182, 58, 0.05) 100%)",
                      opacity: 0,
                      transition: "opacity 0.4s ease",
                      pointerEvents: "none",
                      borderRadius: "20px",
                    }}
                    className="gradient-overlay"
                  />
                  
                  {/* Icon Container */}
                  <div
                    style={{
                      flexShrink: 0,
                      width: size ? "100px" : "80px",
                      height: size ? "100px" : "80px",
                      background: "linear-gradient(135deg, rgba(255, 180, 31, 0.2) 0%, rgba(204, 182, 58, 0.2) 100%)",
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "15px",
                      border: "2px solid rgba(255, 180, 31, 0.3)",
                      marginBottom: size ? "1.5rem" : "1rem",
                      transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                    }}
                  >
                    {React.createElement(area.icon, {
                      className: "focus-area-icon",
                      size: size ? 50 : 40,
                      strokeWidth: 2.5,
                      style: {
                        color: "#ffb41f",
                        filter: "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.3))",
                        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                      },
                    })}
                  </div>

                  {/* Content */}
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    <p
                      className="text-400 text-white mb-0"
                      style={{
                        fontSize: size ? "1.1rem" : "0.95rem",
                        lineHeight: "1.8",
                        fontWeight: "600",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {area.title}
                    </p>
                  </div>

                  {/* Decorative corner accent */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      width: "60px",
                      height: "60px",
                      background: "linear-gradient(135deg, rgba(255, 180, 31, 0.1) 0%, transparent 100%)",
                      borderRadius: "0 20px 0 100%",
                      pointerEvents: "none",
                    }}
                  />
                </Card>
              </Col>
            ))}
          </Row>

          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="mb-5">
                <h1
                  className="m-0 mb-3 text-g"
                  style={{
                    fontSize: size ? "3rem" : "2rem",
                    fontWeight: "700",
                    letterSpacing: "0.5px",
                  }}
                >
                  Event Summary
                </h1>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
                    borderRadius: "2px",
                    marginBottom: "2rem",
                  }}
                />
              </div>
            </Col>

            <Col md={6} className="mb-4">
              <Card
                style={{
                  background: "rgba(255, 255, 255, 0.05)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  borderRadius: "12px",
                  padding: size ? "2rem" : "1.5rem",
                  height: "100%",
                  transition: "all 0.3s ease",
                }}
                className="hover-card"
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.08)";
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow = "0 10px 30px rgba(255, 180, 31, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <p
                  className="text-400 text-white mb-0"
                  style={{
                    fontSize: size ? "1.2rem" : "0.9rem",
                    lineHeight: "1.8",
                  }}
                >
                  Egypt is undergoing one of the most ambitious urban and infrastructure
                  transformations in the region, driven by Vision 2030, large-scale smart city
                  developments, and major investments in transportation, energy, water, and public
                  services. With billions of dollars committed to new cities, modern utilities, and
                  digital infrastructure, there is a growing need for integrated, data-driven tools to
                  manage complex assets, reduce operational risk, and improve service efficiency.
                  Digital twins enable predictive maintenance, scenario planning, and optimized
                  resource management—critical capabilities for rapidly expanding urban environments.
                </p>
              </Card>
            </Col>
            <Col md={6} className="mb-4">
              <Card
                style={{
                  background: "rgba(255, 255, 255, 0.05)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  borderRadius: "12px",
                  padding: size ? "2rem" : "1.5rem",
                  height: "100%",
                  transition: "all 0.3s ease",
                }}
                className="hover-card"
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.08)";
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow = "0 10px 30px rgba(255, 180, 31, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <p
                  className="text-400 text-white mb-0"
                  style={{
                    fontSize: size ? "1.2rem" : "0.9rem",
                    lineHeight: "1.8",
                  }}
                >
                  After the success of the launch edition, the{" "}
                  <span style={{ fontWeight: "600", color: "#ffb41f" }}>
                    2nd Annual Egypt Digital Twin 2026
                  </span>
                  , to be held in{" "}
                  <span style={{ fontWeight: "600", color: "#ffb41f" }}>
                    Cairo on April 22
                  </span>
                  , will be a strategic regional platform focused on accelerating the adoption of
                  digital twin technologies across smart cities, infrastructure, and utilities in
                  Egypt and the wider MENA region. The event will bring together government leaders,
                  city planners, infrastructure authorities, utility operators, technology providers,
                  and investors to explore how real-time data, simulation, and AI can improve
                  planning, operations, and sustainability.
                </p>
              </Card>
            </Col>
            <Col lg={12}>
              <Card
                style={{
                  background: "rgba(255, 180, 31, 0.1)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 180, 31, 0.3)",
                  borderRadius: "12px",
                  padding: size ? "2rem" : "1.5rem",
                  marginTop: "1rem",
                }}
              >
                <p
                  className="text-400 text-white mb-0"
                  style={{
                    fontSize: size ? "1.2rem" : "0.9rem",
                    lineHeight: "1.8",
                  }}
                >
                  Egypt's expanding IoT, fiber, and 5G ecosystems further strengthen the case for
                  large-scale digital twin deployment. This conference will provide actionable
                  insights, real-world use cases, and collaboration opportunities to help
                  stakeholders translate investment into measurable outcomes, positioning Egypt as a
                  digital twin leader in Africa and the Arab world.
                </p>
              </Card>
            </Col>
            <Col md={12} className="pr-0 mt-5">
              <div className="mb-5">
                <h1
                  className="m-0 mb-3 text-g"
                  style={{
                    fontSize: size ? "3rem" : "1.7rem",
                    fontWeight: "700",
                    letterSpacing: "0.5px",
                  }}
                >
                  Conference Format
                </h1>
                <div
                  style={{
                    width: "80px",
                    height: "4px",
                    background: "linear-gradient(90deg, #ffb41f, #ccb63a)",
                    borderRadius: "2px",
                    marginBottom: "2rem",
                  }}
                />
              </div>

              <div className={`container-fluid row`}>
                {content.map((c, i) => (
                  <Col lg={4} xs={6} key={i} className="mb-4">
                    <Card
                      style={{
                        background: "rgba(255, 255, 255, 0.05)",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        borderRadius: "16px",
                        padding: size ? "1.5rem" : "1rem",
                        height: "100%",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                      }}
                      className="conference-card"
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "rgba(255, 180, 31, 0.15)";
                        e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.5)";
                        e.currentTarget.style.transform = "translateY(-5px)";
                        e.currentTarget.style.boxShadow = "0 10px 25px rgba(255, 180, 31, 0.3)";
                        const iconContainer = e.currentTarget.querySelector(".conference-icon-container");
                        const icon = e.currentTarget.querySelector("svg");
                        if (iconContainer) {
                          iconContainer.style.background = "linear-gradient(135deg, rgba(255, 180, 31, 0.4), rgba(204, 182, 58, 0.3))";
                          iconContainer.style.borderColor = "rgba(255, 180, 31, 0.6)";
                          iconContainer.style.transform = "rotate(10deg)";
                        }
                        if (icon) {
                          icon.style.color = "#ffb41f";
                          icon.style.transform = "rotate(-10deg)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                        e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "none";
                        const iconContainer = e.currentTarget.querySelector(".conference-icon-container");
                        const icon = e.currentTarget.querySelector("svg");
                        if (iconContainer) {
                          iconContainer.style.background = "linear-gradient(135deg, rgba(255, 180, 31, 0.2), rgba(204, 182, 58, 0.15))";
                          iconContainer.style.borderColor = "rgba(255, 180, 31, 0.3)";
                          iconContainer.style.transform = "rotate(0deg)";
                        }
                        if (icon) {
                          icon.style.color = "#ccb63a";
                          icon.style.transform = "rotate(0deg)";
                        }
                      }}
                    >
                      <div
                        className="d-flex"
                        style={{
                          flexDirection: size ? "row" : "column",
                          alignItems: size ? "center" : "center",
                          justifyContent: "center",
                          textAlign: size ? "left" : "center",
                        }}
                      >
                        <div
                          className="conference-icon-container"
                          style={{
                            width: size ? "70px" : "80px",
                            height: size ? "70px" : "80px",
                            minWidth: size ? "70px" : "80px",
                            background: "linear-gradient(135deg, rgba(255, 180, 31, 0.2), rgba(204, 182, 58, 0.15))",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: "2px solid rgba(255, 180, 31, 0.3)",
                            marginRight: size ? "1.5rem" : "0",
                            marginBottom: size ? "0" : "1rem",
                            flexShrink: 0,
                            boxShadow: "0 4px 15px rgba(255, 180, 31, 0.2), inset 0 0 20px rgba(255, 180, 31, 0.1)",
                            transition: "all 0.3s ease",
                            transformOrigin: "center center",
                          }}
                        >
                          {React.createElement(c.icon, {
                            size: size ? 35 : 40,
                            strokeWidth: 2.5,
                            style: {
                              color: "#ccb63a",
                              filter: "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.3))",
                              transition: "all 0.3s ease",
                            },
                          })}
                        </div>
                        <div className={size ? "flex-grow-1" : ""}>
                          <p
                            className="text-white mb-0"
                            style={{
                              fontSize: size ? "15px" : "14px",
                              fontWeight: "500",
                              lineHeight: "1.4",
                              letterSpacing: "0.3px",
                            }}
                          >
                            {c.title}
                          </p>
                        </div>
                      </div>
                    </Card>
                  </Col>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Event;

const focusAreas = [
  {
    title: "SMART CITIES",
    icon: Building2,
  },
  {
    title: "CONSTRUCTION",
    icon: HardHat,
  },
  {
    title: "URBAN PLANNING",
    icon: Map,
  },
  {
    title: "INFRASTRUCTURE",
    icon: Settings,
  },
];

const content = [
  {
    title: "VIP KEYNOTES",
    icon: Mic,
  },
  {
    title: "EXHIBITION AND NETWORKING",
    icon: Network,
  },
  {
    title: "DIGITAL TWIN CASE STUDIES AND PROOF OF CONCEPT PRESENTATIONS",
    icon: FileText,
  },
  {
    title: "THOUGHT-PROVOKING PANEL DISCUSSIONS",
    icon: Lightbulb,
  },
  {
    title: "INTERNATIONAL CASE STUDIES AND PROOF OF CONCEPTS",
    icon: Globe,
  },
];
